import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "../App.css"

const AdminSettings = () => {
  const navigate = useNavigate();

  const [settings, setSettings] = useState({
    company_name: '', address: '', address2: '', address3: '',
    town: '', province: '', postcode: '', phone: '', email: '',
    website: '', nie: '', iva_percent: '', logo_path: ''
  });

  useEffect(() => {
    fetch('/api/settings')
      .then(res => res.json())
      .then(data => data && setSettings(data));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings(prev => ({ ...prev, [name]: value }));
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('logo', file);
    try {
      const res = await fetch('/api/upload-logo', { method: 'POST', body: formData });
      const data = await res.json();
      if (data.success) {
        setSettings(prev => ({ ...prev, logo_path: data.logoPath }));
      }
    } catch (err) {
      console.error('Error uploading logo:', err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('/api/settings', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(settings)
      });
      if (res.ok) alert('Settings saved successfully!');
    } catch (err) {
      console.error('Error saving settings:', err);
    }
  };

  return (
    <div className="container">
      <div className="card">
        <h2 className="section-title">Admin Settings</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-grid">
            {Object.entries({
              company_name: 'Company Name', address: 'Address Line 1', address2: 'Address Line 2',
              address3: 'Address Line 3', town: 'Town', province: 'Province', postcode: 'Postcode',
              phone: 'Phone Number', email: 'Email Address', website: 'Website',
              nie: 'NIE Number', iva_percent: 'IVA %'
            }).map(([key, label]) => (
              <div key={key}>
                <div className="label">{label}</div>
                <input
                  type="text"
                  name={key}
                  value={settings[key] || ''}
                  onChange={handleChange}
                  className="input"
                />
              </div>
            ))}
          </div>

          <div className="mt-4">
            <div className="label">Upload Logo</div>
            <input type="file" onChange={handleLogoUpload} />
            {settings.logo_path && (
              <img
                src={settings.logo_path}
                alt="Company Logo"
                className="mt-3"
                style={{ maxHeight: 96, borderRadius: 8, border: '1px solid var(--border)' }}
              />
            )}
          </div>

          {/* Actions */}
          <div
            className="mt-4 right"
            style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}
          >
            <button type="submit" className="btn">Save Settings</button>

            <button
              type="button"
              className="btn cancel"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminSettings;

